const locale = require('./rewriteSubmissionModal.i18n.json');

/*@ngInject*/
const rewriteSubmissionModalController = function ($rootScope, $scope, coreConstant, coreMediator, dateUtil, submissionId, submissionCopyOptions) {

    $scope.i18n = locale;

    var primaryDropdown = {
            name: "Rewrite Reasons",
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId
    };

    $scope.viewModel = {
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get( $scope.i18n, 'cancel'),
        okButton: _.get( $scope.i18n, 'confirm'),
        primaryReasonList: [],
        selectedPrimaryReason: { name: _.get($scope.i18n, 'defaultPrimaryPrompt') },
        primaryReasonIsOptional: false,
        primaryOtherReason: '',
        showPrimaryOtherReason: false,
        comments: '',
        showDates: true,
        startDateLabel: _.get($scope.i18n, 'startDateLabel'),
        endDateLabel: _.get($scope.i18n, 'endDateLabel'),
        startDate: null,
        endDate: null,
        timezoneMode: 'utc',
        fullSubmissionCopyOptions: [submissionCopyOptions.ALL],
        applicationOnlyCopyOptions: [submissionCopyOptions.SUBMISSION_APPLICATION_FORMS]
    };

    $scope.onSelectPrimaryReason = function (choice) {
        $scope.viewModel.selectedPrimaryReason = choice;
        $scope.viewModel.showPrimaryOtherReason = choice.value.toLowerCase() === 'other';
        $scope.viewModel.primaryOtherReason = '';
    };

    $scope.getPrimaryReasonLabel = function () {
        const selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason;
        return selectedPrimaryReason ? selectedPrimaryReason.name : _.get( $scope.i18n, 'defaultPrimaryPrompt');
    };

    $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;

    $scope.onClickFullSubmissionLabel = function () {
        $scope.viewModel.copyOptions = $scope.viewModel.fullSubmissionCopyOptions;
    };

    $scope.onClickApplicationOnlyLabel = function () {
        $scope.viewModel.copyOptions = $scope.viewModel.applicationOnlyCopyOptions;
    };

    $scope.onConfirm = function () {
        var selectedPrimaryReason = '',
            dateRangeInputFormat = coreMediator.getPreferenceByName('view.shortDateFormat');

        if ($scope.viewModel.selectedPrimaryReason) {
            if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
                selectedPrimaryReason = $scope.viewModel.primaryOtherReason;
            } else {
                selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason.value;
            }
        }

        $scope.$close({
            reason: selectedPrimaryReason,
            details: $scope.viewModel.comments,
            startDate: $scope.viewModel.startDate,
            endDate: $scope.viewModel.endDate,
            copyOptions: $scope.viewModel.copyOptions
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    function primaryReasonIsNotSelected() {
        var hasPrimaryReasonSelection = $scope.viewModel.selectedPrimaryReason && $scope.viewModel.selectedPrimaryReason.value,
            primaryOtherReasonIsRequired = $scope.viewModel.showPrimaryOtherReason === true,
            isValidPrimaryOtherReason = primaryOtherReasonIsRequired ? $scope.viewModel.primaryOtherReason.length > 0 : true;

        return !$scope.viewModel.primaryReasonIsOptional && (!hasPrimaryReasonSelection || !isValidPrimaryOtherReason);
    }

    function datesNotSelected() {
        var hasDatesSelected = $scope.viewModel.startDate && $scope.viewModel.endDate;

        return $scope.viewModel.showDates && !hasDatesSelected;
    }

    $scope.dateRangeUpdated = function (value) {
        $scope.viewModel.startDate = dateUtil.parseDateRangeStartDateToMilliseconds(value);
        $scope.viewModel.endDate = dateUtil.parseDateRangeEndDateToMilliseconds(value);
    };

    $scope.canEnableConfirmButton = function () {
        return !(primaryReasonIsNotSelected() || datesNotSelected());
    };

    $scope.showCheckMarkForPrimaryReason = function () {
        return !primaryReasonIsNotSelected();
    };

    coreMediator.getDynamicDataSetItems(primaryDropdown).then(function (result) {
        $scope.viewModel.primaryReasonList = result;
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('rewriteSubmissionModalController', rewriteSubmissionModalController);
